import { Application } from "@hotwired/stimulus"

import "../primer_view_components";
import "../../components/file_browser";
import "../../components/color_mode_toggle";

Application.start();
